// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "Vote": "Vote",
      "StandNumber": "Image number",
      "Email": "E-mail (optional)",
      "AreYouSure": "Are you sure?",
      "Cancel": "Cancel",
      "ScanQrCode": "Scan the qr code",
      "BadStandNumber": "The stand number cannot be empty or a negative number",
      "StandNotFound": "Stand not found",
      "ValidationFailed": "Incorrect stand number or email. Please check the information",
      "VoteOnePerStand": "Each device is allowed to vote for a drawing only once",
      "SuccessVote": "Thank you, you vote has been accepted!",
      "Disclaimer": "Have a nice evening! 🧡",
      "VoteNotStarted": "The event has not started yet",
      "VoteAlreadyEnded": "The event has ended",
    }
  },
  lv: {
    translation: {
      "Vote": "Balsot",
      "StandNumber": "Bildes numurs",
      "Email": "E-pasts (nav nepieciešams)",
      "AreYouSure": "Vai esat pārliecināts?",
      "Cancel": "Atcelt",
      "ScanQrCode": "Skenējiet qr kodu",
      "BadStandNumber": "Stenda numurs nedrīkst būt tukšs vai negatīvs skaitlis",
      "StandNotFound": "Stends nav atrasts",
      "ValidationFailed": "Nepareizs stenda numurs vai e-pasts. Lūdzu, pārbaudiet datus",
      "VoteOnePerStand": "Par vienu zīmējumu no vienas ierīces ir atļauts balsot tikai vienu reizi",
      "SuccessVote": "Paldies, balsojums pieņemts!",
      "Disclaimer": "Lai foršs vakars! 🧡",
      "VoteNotStarted": "Pasākums vēl nav sākies",
      "VoteAlreadyEnded": "Pasākums ir pabeigts"
    }
  }
};

i18n
.use(initReactI18next)
.init({
  resources,
  lng: localStorage.getItem('i18n') || 'lv',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
